import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Input } from '@/components/ui/input';
import { Search, X } from 'lucide-react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

/** The list search box with its leading icon. */
export function SearchInput({ value, onChange, placeholder }: SearchInputProps) {
  return (
    <div className="relative w-full sm:flex-1 sm:max-w-sm">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="pl-9 bg-white border-slate-200"
      />
    </div>
  );
}

export interface FilterOption {
  value: string;
  label: string;
}

interface MultiSelectFilterProps {
  label: string;
  options: readonly FilterOption[];
  selected: string[];
  onToggle: (value: string, checked: boolean) => void;
}

/** Checkbox dropdown filter with the selected-count badge. */
export function MultiSelectFilter({
  label,
  options,
  selected,
  onToggle,
}: MultiSelectFilterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="bg-white border-slate-200 text-slate-600 gap-1.5"
        >
          {label}
          {selected.length > 0 && (
            <span className="bg-emerald-100 text-emerald-700 rounded-full px-1.5 text-[10px] font-bold">
              {selected.length}
            </span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={selected.includes(option.value)}
            onCheckedChange={(checked) => onToggle(option.value, checked)}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

/** « Effacer » ghost button shown when any filter is active. */
export function ClearFiltersButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="text-slate-500 hover:text-slate-700 gap-1"
    >
      <X className="h-3.5 w-3.5" />
      Effacer
    </Button>
  );
}
